/**
 * @generated SignedSource<<bcb51462d9f43d92de4a06d9fc04f974>>
 * @relayHash c63a23027fa9e07208c3313202d77291
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fd05c98c37d56faf7d98617782fb98bf5729e2b323419e6dcce732c621fdb49d

import type { ConcreteRequest } from 'relay-runtime';
export type viewPresenceBootstrapQuery$variables = {
  cloudId: string;
  contentId: string;
  spaceKey: string;
};
export type viewPresenceBootstrapQuery$data = {
  readonly confluence_viewPresenceBootstrap: {
    readonly isEnabledOnContentView: boolean;
    readonly token: string | null;
  } | null;
};
export type viewPresenceBootstrapQuery = {
  response: viewPresenceBootstrapQuery$data;
  variables: viewPresenceBootstrapQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "ConfluenceViewPresenceBootstrap",
    "kind": "LinkedField",
    "name": "confluence_viewPresenceBootstrap",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isEnabledOnContentView"
      },
      {
        "kind": "ScalarField",
        "name": "token"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "viewPresenceBootstrapQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "viewPresenceBootstrapQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c63a23027fa9e07208c3313202d77291",
    "id": "fd05c98c37d56faf7d98617782fb98bf5729e2b323419e6dcce732c621fdb49d",
    "metadata": {},
    "name": "viewPresenceBootstrapQuery",
    "operationKind": "query",
    "text": "query viewPresenceBootstrapQuery($cloudId:ID!,$contentId:ID!,$spaceKey:String!){confluence_viewPresenceBootstrap(cloudId:$cloudId,contentId:$contentId,spaceKey:$spaceKey){isEnabledOnContentView,token}}"
  }
};
})();

(node as any).hash = "207ea4ee88a2f126801b6001c3c8b54b";

export default node;
